export default __webpack_public_path__ + "static/media/main-banner-mobile.1cf7e5ad.png";